// extracted by mini-css-extract-plugin
export default {"title":"_31Edg","dateLocation":"_392RL","LEFT":"_1SmPM","left":"_1SmPM","CENTER":"lzuLL","center":"lzuLL","RIGHT":"_2_uti","right":"_2_uti"};